import { Link as LinkLi } from '@material-ui/core';
import { AUTH_TOKEN, COOKIE_AUTH_DETAILS, pageUrls } from 'globalconfig/constants/keys';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import { getCookie } from 'globalservices/cookie';
import { getCurrentLanguage } from 'globalutils/commonUtils';
import { isCRMImport, isInsuracePortalUser } from 'globalutils/fmUtils';
import React, { lazy, useState } from 'react';
import { Link } from 'react-router-dom';
import { checkServiceProvider } from './serviceProviderConfig';

const layout = window?.$environment?.CURRENT_LAYOUT;
const SERVICE_PROVIDER = window?.$environment?.SERVICE_PROVIDER;
const Search = lazy(() => import(`globalcomponents/UI/SimpleSearch/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Export = lazy(() => import(`globalcomponents/UI/Export/${layout}`));
const Import = lazy(() => import(`globalcomponents/UI/Import/${layout}`));
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const Breadcrumb = lazy(() => import(`globalcomponents/Breadcrumb`));
const Modal = require(`globalcomponents/UI/Modal/${layout}`).default;
const SvgIcon = lazy(() => import(`globalcomponents/SvgIcon/${layout}`));

const TopActions = ({
  users,
  callback,
  filterSuccess,
  handleExportUser,
  handleImportUser,
  Styled,
  i18n,
  logBook,
  setPagination,
  filterButtons,
  setButtons,
  filters,
  removeData,
  setremoveData,
  viewExportOptions,
  isMechanicUser,
  newUI,
}) => {
  const beBaseUrl = window?.$environment?.BE_BASE_URL;
  const [ModalMessageObject, setModalMessageObject] = useState({
    header: '',
    content: () => {},
  });
  const [openMessageModal, setOpenMessageModal] = useState(false);

  const selectChange = (e) => {
    filterSuccess(e);
    setPagination(true);
    setButtons(
      filterButtons.length &&
        filterButtons.map((key, i) => {
          if (i === 0) return { ...key, selected: true };
          else return { ...key, selected: false };
        })
    );
    setremoveData('false');
  };

  const exportUser = () => {
    handleExportUser({
      id: 'exportUser',
    });
  };

  const importUser = (file) => {
    handleImportUser({
      data: file,
      apiId: 'importUser',
      callback: (type, error, func = () => {}, ers, option) => {
        return callback(type, error, func, ers, option, true);
      },
    });
    if (document.getElementById('fileSelectimportVeh')) document.getElementById('fileSelectimportVeh').value = '';
    if (document.getElementById('fileSelect')) document.getElementById('fileSelect').value = '';
  };

  const exportUserTemplate = () => {
    let url = isCRMImport()
      ? beBaseUrl + '/user/mini-import/template'
      : beBaseUrl + '/user/csvtemplate' + '?token=' + logBook?.documentToken;

    const iframe = document.getElementById('importUserTemplateFrame');
    const token = getCookie(COOKIE_AUTH_DETAILS)[AUTH_TOKEN];
    iframe.contentWindow
      .fetch(url, {
        headers: {
          'Accept-Language': getCurrentLanguage(),
          ...(isCRMImport() ? { Authorization: 'Bearer ' + token } : {}),
        },
      })
      .then((response) => {
        if (response.ok) {
          response.blob().then((blob) => {
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = isCRMImport() ? 'User_mini_import_template.csv' : 'User_import_template.csv';
            a.click();
          });
        } else {
          console.log('Error: ' + response.status);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Styled.Wrapper>
      {layout !== 'OldUi' && <Breadcrumb filters={filters} />}
      <Styled.TopWrapper alignRight={!viewExportOptions}>
        {window.$environment.CURRENT_LAYOUT !== 'SpireonNew' && (
          <Styled.SearchWrapper>
            <Search
              onChange={(e) => selectChange(e)}
              default={[...users.list]}
              fromData={isInsuracePortalUser()}
              placeHolder={i18n.t('vehicles.searchUser')}
              query={'full_name'}
              id="searchUser"
              onRemove={removeData}
            ></Search>
          </Styled.SearchWrapper>
        )}
        {checkServiceProvider('topAction_iconWrapper', SERVICE_PROVIDER) && (
          <Styled.IconWrapper>
            <LinkLi component={Link} to={isMechanicUser ? pageUrls.addMechanic : pageUrls.addUser} className="userNew">
              <Icon src={mediaUrls?.addVehicle} primary />
            </LinkLi>
            <LinkLi component={Link} to={pageUrls.addUser} className="addUserButtonhover userOld">
              <Button component={Link} variant="body2" className="linkStyle addUser" label={i18n.t('users.addNewUser')}></Button>
            </LinkLi>
          </Styled.IconWrapper>
        )}
        {viewExportOptions && (
          <Styled.ImpExpWrapper>
            {checkServiceProvider('topAction_impExpWrapper', SERVICE_PROVIDER, false) && (
              <>
                <Export
                  exportUserTemplate
                  src={layout === 'Clutch' ? mediaUrls?.excel : mediaUrls.importUserTemplate}
                  filename={'users'}
                  toolTip={i18n.t('vehicles.importUserTemplate')}
                  className="importUserTemplateContainer"
                  onClick={() => exportUserTemplate()}
                  buttonName={i18n.t('vehicles.importUserTemplate')}
                  newUI={newUI}
                />
                <Import
                  userImport
                  className="importUserContainer userNew"
                  toolTip={i18n.t('vehicles.importUserTemplate')}
                  onClick={(e) => {
                    if (checkServiceProvider('topAction_import', SERVICE_PROVIDER, false)) {
                      setModalMessageObject({
                        content: () => (
                          <div className="deleteParent">i think thsr
                            <div className="imageSection">
                              <SvgIcon value={mediaUrls.confirmIcon} alt="Are you sure" />
                            </div>
                            <h2>{i18n.t('common.insurancePortalWarning')}</h2>
                            <div className="deletePopupBtn">
                              <div className="cancelBtn">
                                <Button
                                  label={i18n.t('common.ok')}
                                  type={'reset'}
                                  onClick={() => {
                                    setOpenMessageModal(false);
                                    if (document.getElementById('fileSelect')) document.getElementById('fileSelect').value = '';
                                  }}
                                ></Button>
                              </div>
                              <div className="deletebtn">
                                <Button
                                  label={i18n.t('common.proceedToImport')}
                                  onClick={() => {
                                    setOpenMessageModal(false);
                                    importUser(e);
                                  }}
                                ></Button>
                              </div>
                            </div>
                          </div>
                        ),
                      });
                      setOpenMessageModal(true);
                    } else {
                      importUser(e);
                    }
                  }}
                  asBinary
                  reqDataModel={'multipartFile'}
                  buttonName={i18n.t('vehicles.importUserTemplate')}
                  newUI={newUI}
                />
                <Import
                  className="importUserContainer userOld"
                  toolTip={i18n.t('vehicles.importUserTemplate')}
                  onClick={(e) => importUser(e)}
                  asBinary
                  reqDataModel={'multipartFile'}
                  importVehicle={i18n.t('common.importUser')}
                  id="importVeh"
                  newUI={newUI}
                />
              </>
            )}
            <Export
              src={['NewUi', 'SpireonNew'].includes(layout) ? mediaUrls.exportUserCircle : mediaUrls.exportUser}
              filename={'users'}
              toolTip={i18n.t('vehicles.exportUser')}
              className="exportContainer"
              onClick={() => exportUser()}
              buttonName={i18n.t('vehicles.exportUser')}
              newUI={newUI}
            />
          </Styled.ImpExpWrapper>
        )}
        <Modal open={openMessageModal} setOpen={setOpenMessageModal} data={ModalMessageObject} deletePopup />
        <iframe title="importUserTemplateFrame" id="importUserTemplateFrame" style={{ display: 'none' }}></iframe>
      </Styled.TopWrapper>
      <div className="breadcrumbClass">{layout === 'OldUi' && <Breadcrumb filters={filters} />}</div>
    </Styled.Wrapper>
  );
};
export default TopActions;
